import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MensagemUsuario } from '../../models/chat-bot.model';
import { ActionTable, ColumnsTable } from 'src/app/shared/models/table.model';
import { FilterTable } from 'src/app/shared/models/filter.model';
import { SuporteLocalService } from '../../services/suporte-local.service';
import { ActivatedRoute } from '@angular/router';
import { Ativo } from 'src/app/shared/models/enumerations.model';

@Component({
  selector: 'app-suporte-local-list',
  templateUrl: './suporte-local-list.component.html',
  styleUrls: ['./suporte-local-list.component.scss']
})
export class SuporteLocalListComponent extends BaseFormComponent<MensagemUsuario> implements OnInit, OnDestroy {
	
	listColumns: ColumnsTable[] = [
		{id:'pergunta', name: 'Pergunta', title: 'Pergunta', class: '', type: 'string'},
		{id:'nome_usuario_pergunta', name: 'Usuário', title: 'Usuário', class: '', type: 'string'},
		//{id:'suporte_respondido', name: 'Respondido', title: 'Respondido', class: '', type: 'boolean'},
		{id:'status', name: 'Status', title: 'Status', class: '', type: 'string'},
  	];
	data: MensagemUsuario[] = [];
	listActions: ActionTable[] = [];
	filterForm: FilterTable[] = [
		{key: 'pergunta', value: '', type: 'string', class: 'col-12 col-md-6', label: 'Pergunta'},
		{key: 'nome_usuario_pergunta', value: '', type: 'string', class: 'col-12 col-md-6', label: 'Usuário'},
		{key: 'suporte_respondido', value: null, type: 'select', class: 'col-12 col-md-6', label: 'Respondido', options: Ativo}
	];
	filters: any;

	constructor(
		public myServices: SuporteLocalService,
		public activatedRoute: ActivatedRoute,
	) {
		super(activatedRoute);
	}

	ngOnDestroy(): void {
		this.unsubscribeList();
	}

	ngOnInit() {
		this.loading();
		this.get();
	}

	get(): void {
		this.myServices.findAll().subscribe({
			next: (res:MensagemUsuario[]) => {
				this.data = res.map(r => {
					var status = 'Em aberto';
					if(r.suporte_respondido){
						var status = 'Fechado';
					}
					else{
						if(r.suporte_geral_solicitado){
							if(r.suporte_geral_respondido){
								status = 'Respondido por SPGG';
							}
							else{
								status = 'Aguardando retorno SPGG.';
							}
						}
					}
					r.status = status;
					return r;
				});
				console.log(this.data)
				this.loaded();
			},
			error: (error) => {
				this.loaded();
				this.msgError(error?.error?.message ?? "Ocorreu um erro interno")
			},
		});
	}

}